import { render, staticRenderFns } from "./setBanner.vue?vue&type=template&id=dcad0c5e&scoped=true&"
import script from "./setBanner.vue?vue&type=script&lang=js&"
export * from "./setBanner.vue?vue&type=script&lang=js&"
import style0 from "./setBanner.vue?vue&type=style&index=0&id=dcad0c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcad0c5e",
  null
  
)

export default component.exports